import { Component, OnInit } from "@angular/core";
import { UsersService } from "@service/admin/users.service";
import { MatTableDataSource } from "@angular/material/table";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-modal-pending-pix",
  templateUrl: "./modal-pending-pix.component.html",
  styleUrls: ["./modal-pending-pix.component.scss"],
})
export class ModalPendingPixComponent implements OnInit {
  public dataSource = new MatTableDataSource<any>();
  public displayedColumns: string[] = [
    "date",
    "description",
    "points",
    "total",
    "type",
    "pix_key",
    "status",
  ];

  constructor(
    private usersService: UsersService,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    this.usersService.getPendingPix().subscribe((res) => {
      console.log(res);
      const rows = new Array<any>();
      res.pix.forEach((item) => {
        rows.push({
          pix_key: item.pix_key,
          name: item.name,
          description: item.description,
          type: item.type,
          value: item.value,
          status: item.status,
          date: item.request_date,
          paid: item.paid_at,
        });
      });
      this.dataSource.data = [...rows];
    });
  }

  dismiss() {
    this.activeModal.dismiss();
  }
}
